import React, { useState, useContext, useEffect } from 'react'
import { GlobalContext } from '../../../Context/GlobalContext.js';
import axios from "axios";
import { BASE_PATH } from '../../../constants/awsBaseUrl.js';

/* 
  Login Modal appears when non logged in user attempts 
  to interact with site specific features with out a profile,
  thus prompting them to create an account 
*/
const Login = ({
  companyId,
  visible,
  close,
  login
}) => {

  const { setViewerId, setViewerObj, darkMode } = useContext(GlobalContext);
  const VALID_EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const [ message, setMessage ] = useState('');
  const [ page, setPage ] = useState('login');
  const [ email, setEmail ] = useState('');
  const [ password, setPassword ] = useState('');
  const [ confirmPassword, setConfirmPassword ] = useState('');

  const API_URL = "https://310nwnmom8.execute-api.us-west-2.amazonaws.com";
  const LOG_URL = `url('${BASE_PATH}/logos/${companyId}/banner.jpg?refresh=${new Date().getMonth()}${new Date().getDate()}${new Date().getFullYear()}')`

  const submitLoginDetails = async () => {
    setMessage('');
    const validEmail = VALID_EMAIL_REGEX.test(email);
    if(!validEmail) return setMessage('Please enter a valid email address');
    if(!password) return setMessage('Please enter your password');

    try{
      const { data } = await axios.post(`${API_URL}/login`, {
        email,
        password,
        publicUserId: companyId,
      })
      const { viewerObj } = data;

      // set the user object to the global context
      setViewerId(viewerObj._id);
      setViewerObj(viewerObj);
      login(viewerObj, {
        email,
        password,
        page,
        message,
      });

    }catch(error) {
      setMessage(error.response.data.message)
    } 
  }

  const registerNewViewer = async () => {
    setMessage('');
    const validEmail = VALID_EMAIL_REGEX.test(email);
    if(!validEmail) return setMessage('Please enter a valid email address');
    if (password !== confirmPassword) return setMessage("Passwords must match");

    try{
      const { data } = await axios.post(`${API_URL}/register`, {
        email,
        password,
        publicUserId: companyId
      });

      const { viewerObj } = data;

      setViewerId(viewerObj._id);
      setViewerObj(viewerObj);
      login(viewerObj, {
        email,
        password,
        page,
        message,
      });

    } catch(error) {
      setMessage(error.response.data.message);
    }
  }

  // reset all values back to default when modal closes
  useEffect(() => {
    setEmail('');
    setPassword('');
    setConfirmPassword('');
    setMessage('');
  },[visible])

  if(page === 'login'){
    return (
      <div className={visible ? "login-wrapper" : "d-none"}>
        <div className="login-body">
          <div className="login-x" style={{color:darkMode?'black':''}} onClick={() => close()}>
            <i className="fas fa-times"></i>
          </div>

          <div
            className="login-title"
            style={{
              backgroundImage: `url('${BASE_PATH}/logos/${companyId}/banner.jpg?refresh=${new Date().getMonth()}${new Date().getDate()}${new Date().getFullYear()}')`,
            }}
          ></div>

          <h1 className="display-4 sm border-bottom">Login</h1>

          <div className="form-group">
            <input
            autoComplete='username'
              className="form-control"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="form-group">
            <input
            autoComplete='current-password'
              className="form-control"
              placeholder="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div className="form-group">
            <button
              className="btn btn-primary bg-primary btn-block"
              onClick={submitLoginDetails}
            >
              Submit
            </button>
          </div>

          <div className={message.length > 0 ? "form-group" : ""}>
            <button
              className="btn btn-info btn-block"
              onClick={() => setPage("register")}
            >
              Don't have an account? Click here to register
            </button>
          </div>

          <div className={""} style={{ marginTop: 15 }}>
            <button
              className="btn btn-info btn-block"
              onClick={() => {
                window.location.href =
                  window.location.href.split("?")[0] + "/forgot-password";
              }}
            >
              Forgot password?
            </button>
          </div>

          {/* display error message */}
          {message && (
            <div className="alert alert-danger" onClick={() => setMessage("")}>
              {message}
            </div>
          )}
        </div>
      </div>
    )
  } 
  else {
    return (
      <div className={visible ? "login-wrapper" : "d-none"}>
        <div className="login-body">
          <div className="login-x" onClick={() => close()}>
            <i className="fas fa-times "></i>
          </div>
          <div
            className="login-title"
            style={{
              backgroundImage: `url('${BASE_PATH}/logos/${companyId}/banner.jpg?refresh=${new Date().getMonth()}${new Date().getDate()}${new Date().getFullYear()}')`,
            }}
          ></div>
          <h1 className="display-4 sm border-bottom">Register</h1>
          <div className="form-group">
            <input
              className="form-control"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value) }
            />
          </div>
          <div className="form-group">
            <input
              className="form-control"
              placeholder="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div className="form-group">
            <input
              className="form-control"
              placeholder="Confirm Password"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>
          <div className="form-group">
            <button
              className="btn btn-primary bg-primary btn-block"
              onClick={registerNewViewer}
            >
              Submit
            </button>
          </div>
          <div className={message ? "form-group" : ""}>
            <button
              className="btn btn-info btn-block"
              onClick={() => setPage("login")}
            >
              Have an account? Click here to login
            </button>
          </div>

          {/* display error message */}
          {message && (
            <div className="alert alert-danger" onClick={() => setMessage("")}>
              {message}
            </div>
          )}
        </div>
      </div>
    );
  }
};

export default Login;
